<template>
  <div class="ace-logos">
    <div class="ace-logos--blonk">
      <img
        srcset="@/assets/images/logo-blonk.png, @/assets/images/logo-blonk@2x.png 2x"
        src="@/assets/images/logo-blonk.png"
        alt="Blonk Consultants logo"
      />
      <span>Independently verified by Blonk Consultants</span>
    </div>
    <div class="ace-logos--other">
      <img
        srcset="@/assets/images/logo-sfi.png, @/assets/images/logo-sfi@2x.png 2x"
        src="@/assets/images/logo-sfi.png"
        alt="Science Foundation Ireland logo"
      />
      <img
        srcset="@/assets/images/logo-ucd.png, @/assets/images/logo-ucd@2x.png 2x"
        src="@/assets/images/logo-ucd.png"
        alt="UCD Dublin logo"
      />
      <img
        srcset="@/assets/images/logo-biorbic.png, @/assets/images/logo-biorbic@2x.png 2x"
        src="@/assets/images/logo-biorbic.png"
        alt="Biorbic logo"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.ace-logos {
  margin: 60px auto 0;
  max-width: 680px;
  &--blonk,
  &--other {
    display: flex;
  }
  &--blonk {
    flex-direction: column;

    align-items: center;
    span {
      margin-top: 5px;

      display: block;

      font-size: 15px;
    }
  }
  &--other {
    margin-top: 60px;

    justify-content: center;
    img {
      & + img {
        margin-left: 20px;
      }
    }
  }
}
</style>
